class RemoveAccountLogo {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}
}

export default RemoveAccountLogo;
